import React from "react"
import Skeleton from "react-loading-skeleton"
import ScrollBar from "react-perfect-scrollbar"
import { useSelector } from "react-redux"
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap"
import { inspectionCheck } from "../../inspectionCheck"
import ModalRemarks from "./ModalRemarks"

function InspectionChecklist(props) {
  const {
    validation,
    checkAllInspectorEditable,
    checkAllProducerEditable,
    setCheckAllInspectorEditable,
    setCheckAllProducerEditable,
  } = props

  const store = useSelector(state => state)
  const [isOpen, setIsOpen] = React.useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const detailOrder = store.inspection.detailOrder.data

  if (store.inspection.detailOrder.loading) {
    return <Skeleton count={5} />
  }

  return (
    <>
      <ModalRemarks isOpen={isOpen} toggle={toggle} {...props} />
      <Card>
        <CardBody>
          <ScrollBar style={{ height: 620 }}>
            <Row>
              <Col>
                {detailOrder.orderNumber}/{detailOrder.customerName}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="4">製作者</Col>
              <Col md="8">{detailOrder.producers.join(", ")}</Col>
            </Row>
            <Row className="mt-3">
              <Col md="4">ステータス</Col>
              <Col md="4">{detailOrder.status}</Col>
              <Col md="4">
                <Button color="warning" onClick={toggle}>
                  備考
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <td>検品項目</td>
                    <td>
                      <p>製作者</p>
                      <Input
                        type="checkbox"
                        disabled={!detailOrder.producerEditable}
                        value={checkAllProducerEditable}
                        checked={checkAllProducerEditable}
                        onClick={() => {
                          setCheckAllProducerEditable(!checkAllProducerEditable)
                        }}
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    </td>
                    <td>
                      <p>検品者</p>
                      <Input
                        type="checkbox"
                        disabled={!detailOrder.inspectorEditable}
                        value={checkAllInspectorEditable}
                        checked={checkAllInspectorEditable}
                        onClick={() => {
                          setCheckAllInspectorEditable(
                            !checkAllInspectorEditable
                          )
                        }}
                        style={{
                          height: "18px",
                          width: "18px",
                        }}
                      />{" "}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {inspectionCheck.map((i, k) => (
                    <tr key={k}>
                      <td>{i.title}</td>
                      <td>
                        <Input
                          type="checkbox"
                          disabled={!detailOrder.producerEditable}
                          value={
                            detailOrder.producerEditable
                              ? validation.values[i.name]
                              : detailOrder.producer[i.name]
                          }
                          checked={
                            detailOrder.producerEditable
                              ? validation.values[i.name]
                              : detailOrder.producer[i.name]
                          }
                          onClick={e => {
                            validation.setFieldValue(
                              i.name,
                              !validation.values[i.name]
                            )
                          }}
                          style={{
                            height: "18px",
                            width: "18px",
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          type="checkbox"
                          disabled={!detailOrder.inspectorEditable}
                          value={
                            detailOrder.inspectorEditable
                              ? validation.values[i.name]
                              : detailOrder.inspector[i.name]
                          }
                          checked={
                            detailOrder.inspectorEditable
                              ? validation.values[i.name]
                              : detailOrder.inspector[i.name]
                          }
                          onClick={e => {
                            validation.setFieldValue(
                              i.name,
                              !validation.values[i.name]
                            )
                          }}
                          style={{
                            height: "18px",
                            width: "18px",
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
            <div className="d-flex justify-content-center">
              {store.inspection.postOrder.loading ? (
                <Skeleton height={30} width={50} />
              ) : (
                <Button type="submit" color="primary">
                  保存
                </Button>
              )}
            </div>
          </ScrollBar>
        </CardBody>
      </Card>
    </>
  )
}

export default InspectionChecklist
